import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import classNames from 'classnames';

// รูป icon
import homeIcon from '../../assets/images/home-icon.png';
import activeHomeIcon from '../../assets/images/active-home-icon.png';
import couponIcon from '../../assets/images/coupon-icon.png';
import activeCouponIcon from '../../assets/images/active-coupon-icon.png';
import dealIcon from '../../assets/images/deal-icon.png';
import activeDealIcon from '../../assets/images/active-deal-icon.png';
import bigpointIcon from '../../assets/images/bigpoint-icon.png';

export default function Footer() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = [
    {
      name: t('home'),
      icon: homeIcon,
      activeIcon: activeHomeIcon,
      to: '/',
    },
    {
      name: t('my_coupon'),
      icon: couponIcon,
      activeIcon: activeCouponIcon,
      to: '/my-coupons',
    },
    {
      name: t('all_coupons'),
      icon: dealIcon,
      activeIcon: activeDealIcon,
      to: '/bc-coupons',
    },
    {
      name: t('my_big_point'),
      icon: bigpointIcon,
      activeIcon: bigpointIcon,
      to: '/my-bigpoint',
    },
  ];

  const renderMenuItem = ({ name, icon, activeIcon, to }) => {
    const isActive = location.pathname === to;

    return (
      <div
        key={to}
        onClick={() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'main_menu_click',
          menu_name: name,
          menu_target: to,
        });

        navigate(to);
      }}
        className={classNames(
          'w-full flex flex-col gap-1 justify-end items-center cursor-pointer',
          { 'text-primary border-t-4 border-primary': isActive }
        )}
      >
        <img src={isActive ? activeIcon : icon} alt={name} className="w-10 h-auto" />
        <div className="text-xs xs:text-[0.625rem] font-medium">{name}</div>
      </div>
    );
  };

  return (
    <div className="bg-white w-full max-w-md h-20 pb-5 z-[888] grid grid-cols-4 justify-items-center fixed bottom-0">

      {menuItems.map(renderMenuItem)}
    </div>
  );
}
